import { ICalendarEvent } from "components";
import { IHomeCalendarData } from "../Home";

// Looks like "Fryer Controller - Stage 1"
export function getEventLabel(
    event: ICalendarEvent<IHomeCalendarData>,
): string {
    const update = event.data.update;

    if (event.isGroupGap) {
        const prevStageNum = event.groupGapPrevEvent.data.stageIndex + 1;
        const nextStageNum = event.groupGapNextEvent.data.stageIndex + 1;
        return `${update.name} - Gap between stage ${prevStageNum} and ${nextStageNum}`;
    } 
    
    // Only put "Stage 1" in the name if the update has more than 1 stage
    if (update.rollout.stages?.length > 1) {
        return `${update.name} - Stage ${event.data.stageIndex + 1}`
    }

    return update.name;
}